import { Styles } from "@material-ui/core/styles/withStyles";
import { Theme } from "@material-ui/core";

export const styles: Styles<Theme, {}> = theme => ({
    card: {
        width: 275,
        marginTop: theme.spacing(4),
    },
    cardFloat: {
        width: 275,
        height: 155,
        float: "left" as const,
        marginRight: theme.spacing(4),
    },
    cardTitle: {
        paddingBottom: theme.spacing(2),
        fontWeight: 600
    },
    addressError: {
        color: "red"
    },
});

export default styles;
